const forgotPassword = {
  email: "Email",
  forgot_password: "Forgot Password",
  welcometext_forgot:
    "Please enter your email and we will send you instructions to reset your password.",
  backtologin: "Back to login",
  submit: "Submit",
  error_email_required: "Email is required",
  error_valid_email: "Please enter valid email address",
  error_something_went_wrong: "Something Went Wrong...",
};
export default forgotPassword;
